// extracted by css-extract-rspack-plugin
export default {"testGeo":"testGeo__mPer9","testGeo__map":"testGeo__map__IdJJb","testGeo__footer":"testGeo__footer__vAjiz","testGeo__button":"testGeo__button__dnJyP"};